import FetchJson from "./fetchJson";

export default class FetchText extends FetchJson {
  async call(path, options = {}) {
    const requestHeaders = this.options.headers();

    /**
     * Some providers, such as MediaObject provider, has different URLS
     * for POST and GET requests. The line below adds an option to provide dynamic URL path
     * in different Http methods.
     */
    const requestUrl = this.url ? `${this.url}/${path}` : path;

    // This functions sets a custom type for PATCH methods
    // TODO: Should be set in createHeadersFromOptions function, however
    // I havent managed to modify headers in that function, please look into this later
    if (options && options.method === "PATCH") {
      requestHeaders.set("Content-Type", "application/merge-patch+json");
    }

    let response = await fetch(requestUrl, {
      ...options,
      ...this.options,
      headers: requestHeaders,
      credentials: "include",
    });

    let text = await response.text();
    let { status, headers } = await response;

    if (status === 401) {
      try {
        await this.refreshToken();
        response = await fetch(requestUrl, {
          ...options,
          ...this.options,
          headers: requestHeaders,
          credentials: "include",
        });
        text = await response.text();

        status = response.status;
        headers = await response.headers;
      } catch (e) {
        return Promise.reject({
          status,
          data: text,
        });
      }
    }

    if ((status < 200 || status >= 300) && status !== 401) {
      return Promise.reject({
        status,
        data: text,
      });
    }

    return Promise.resolve({
      status,
      headers: [...headers.keys()].reduce((o, key) => {
        return {
          ...o,
          [key]: headers.get(key),
        };
      }, {}),
      data: text,
    });
  }
}
